export const state = {
    modals: [
    ],
    counter: 0,
}
